import { Injectable, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';

@Injectable({
  providedIn: 'root'
})
export class EventEmitterService {

  WalletBalance = new EventEmitter();
  subsVar: Subscription;

  constructor() { }
  invokeWalletBalance() {
    this.WalletBalance.emit();
  }
}